import { render, staticRenderFns } from "./RestaurantList.vue?vue&type=template&id=41079a20&"
import script from "./RestaurantList.vue?vue&type=script&lang=ts&"
export * from "./RestaurantList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports